
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ConfirmEmail extends Vue {
  private codeSent = false;

  private colors = {
    lightGray: '#b4b4c4',
  }

  get email(): string {
    return this.$store.getters.getEmail;
  }

  private submit(): void {
    this.$emit('next');
  }

  private sendCode(): void {
    this.codeSent = true;

    setTimeout(() => {
      this.codeSent = false;
    }, 2000);
  }
}
